var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSass800X800(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    height: "800px",
    width: "800px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0,
    id: "SVGRepo_bgCarrier"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    id: "SVGRepo_tracerCarrier"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M12 0C18.6 0 24 5.4 24 12C24 18.6 18.6 24 12 24C5.4 24 0 18.6 0 12C0 5.4 5.4 0 12 0ZM9.6 15.975C9.75 16.65 9.75 17.25 9.6 17.775L9.525 18C9.525 18.075 9.45 18.15 9.45 18.15C9.3 18.45 9.15 18.675 8.925 18.975C8.25 19.725 7.275 20.025 6.825 19.8C6.375 19.575 6.6 18.45 7.425 17.625C8.325 16.725 9.525 16.125 9.525 16.125L9.6 15.975ZM19.5 5.1C18.975 3 15.45 2.25 12.075 3.45C10.125 4.2 7.95 5.325 6.375 6.75C4.5 8.475 4.275 9.975 4.35 10.575C4.8 12.75 7.8 14.25 9.075 15.3C8.7 15.45 6 16.8 5.4 18.225C4.725 19.725 5.475 20.775 6 20.85C7.575 21.3 9.225 20.475 10.05 19.2C10.875 17.925 10.8 16.35 10.425 15.525C10.95 15.375 11.475 15.3 12.225 15.45C14.325 15.675 14.775 17.025 14.625 17.55C14.475 18.075 14.1 18.375 13.95 18.525C13.8 18.6 13.725 18.675 13.8 18.675C13.8 18.75 13.875 18.75 14.025 18.75C14.175 18.75 15.15 18.3 15.15 17.25C15.225 15.975 13.95 14.55 11.775 14.55C10.875 14.55 10.275 14.625 9.9 14.775C9.9 14.7 9.825 14.7 9.825 14.7C8.475 13.275 6 12.225 6.075 10.275C6.075 9.6 6.375 7.725 10.875 5.475C14.55 3.6 17.55 4.125 18.075 5.25C18.825 6.825 16.5 9.825 12.675 10.275C11.175 10.425 10.425 9.9 10.275 9.675C10.05 9.45 10.05 9.45 9.975 9.45C9.825 9.525 9.9 9.675 9.975 9.825C10.125 10.125 10.575 10.65 11.4 10.95C12.075 11.175 13.8 11.325 15.9 10.5C18.225 9.6 20.025 7.125 19.5 5.025V5.1Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSass800X800);
export default __webpack_public_path__ + "static/media/sass-800x800.4993ae6780a933dbf72d97ecd0cbc1d7.svg";
export { ForwardRef as ReactComponent };